<template>
  <ul
    v-if="borderCountries.length"
    :class="$attrs.class"
  >
    <li
      v-for="alphaCode in borderCountries"
      :key="alphaCode"
    >
      <BorderCountryItem :alpha-code="alphaCode" />
    </li>
  </ul>
</template>

<script>
import BorderCountryItem from '@/components/BorderCountryItem.vue';

export default {
  components: {
    BorderCountryItem,
  },
  inheritAttrs: false,
  props: {
    borderCountries: {
      type: Array,
      required: true,
    },
  },
};
</script>
